const baseUrl = process.env.PUBLIC_URL

export function publicUrlFor(path) {
    return baseUrl + "/assets/" + path;
}

// Track loaded scripts globally
const loadedScripts = new Set();

export function loadScript(src, fromPublic) {
    return new Promise(function (resolve, reject) {
        const scriptSrc = (
            fromPublic === undefined ||
            fromPublic == null ||
            fromPublic
        ) ? publicUrlFor(src) : src;
        
        // Check if script is already loaded using our tracking
        if (loadedScripts.has(scriptSrc)) {
            resolve();
            return;
        }
        
        // Double check in DOM
        const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
        if (existingScript) {
            loadedScripts.add(scriptSrc);
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = scriptSrc;
        script.async = true;
        
        // Add data attribute to identify our scripts
        script.setAttribute('data-react-script', 'true');

        script.addEventListener('load', function () {
            loadedScripts.add(scriptSrc);
            resolve();
        });
        
        script.addEventListener('error', function (e) {
            // Don't try to remove on error - let React handle cleanup
            reject(e);
        });
        
        // Use head instead of body to avoid conflicts with React's body management
        document.head.appendChild(script);
    });
}

// Optional: Function to cleanup scripts when needed
export function cleanupScripts() {
    const scripts = document.querySelectorAll('script[data-react-script="true"]');
    scripts.forEach(script => {
        if (script.parentNode) {
            script.parentNode.removeChild(script);
        }
    });
    loadedScripts.clear();
}